import React, { useState, useEffect, memo } from "react";
import Cookies from "js-cookie";
import "../styles/Demo.css";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import GridViewIcon from "@mui/icons-material/GridView";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Footer from "./Footer/Footer";
import { useLocation } from "react-router-dom";
import {
  clearDetailsToSend,
  setDetailsToSend,
} from "../redux/slice/detailsToSendSlice.js";
import useUserData from "../Common/updateUser/updateUser";
import { ImagesPath } from "../Common/imagespath/imagespath";
import { setFeatures } from "../redux/slice/activeFeaturesSlice.js";
import {
  getSettlementDisplayName,
  isFeatureActive,
} from "../Common/serviceActiveCheck/serviceActiveCheck";
import axios from "axios";
import Loaders from "./ReusebleComponents/Loaders";
import { data } from "../Common/Text/NormalText.js";
import { GetWebAccessToken } from "./ReusebleComponents/ResuseableApiCalls.jsx";
import Call_Api from "../Common/Handileapi/Call_api.js";
import { path } from "../routes/Paths";
import { getPathItems } from "../Common/creditCardBinAPI/CommonFunctions.js";
import { StoreImage } from "../redux/slice/userDetailsSlice.js";

const Demo = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userName, getUserDetails } = useUserData();
  const userDetails = useSelector((state) => state?.user?.user);
  const detailsToSend = useSelector((state) => state?.details?.details);
  const userImage = useSelector((state) => state?.user?.image);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [phNo, setPhNo] = useState("");
  // const [selectedMenu, setSelectedMenu] = useState(() => {
  //   return localStorage.getItem("selectedMenu") || "dashboard";
  // });
  // const [selectedMenuTitle, setSelectedMenuTitle] = useState(() => {
  //   return localStorage.getItem("selectedMenuTitle") || "Dashboard";
  // });
  const [selectedMenu, setSelectedMenu] = useState("dashboard");
  const [selectedMenuTitle, setSelectedMenuTitle] = useState("Dashboard");
  const [isMobile, setIsMobile] = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});
  const features = useSelector((state) => state.activeFeatures.features);
  const [searchText, setSearchText] = useState("");
  const [menuKey, setMenuKey] = useState(0);
  const [activeFeaturesLoading, setActiveFeaturesLoading] = useState(true);
  const [activeFeatures, setActiveFeatures] = useState([]);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const hiddenFooterPaths = [
    "/PaymentLinks",
    "/History",
    "/Dashboardpage",
    "/Settlement",
    "/SettlementDetails",
    "/Analytics",
    "/Users",
    "/Payouts",
  ];
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const isHomeRoute = location.pathname;
  const token = Cookies.get("token");
  const isAuthenticated = !!token;

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleSubmenu = (key) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleResize = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
      setSidebarOpen(false);
    } else {
      setIsMobile(false);
      setSidebarOpen(true);
      setMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    // const path =
    //   window.location.pathname.substring(1)?.split("/")?.[1] ||
    //   window.location.pathname.split("/")[1] ||
    //   "Dashboardpage";

    const path = location.pathname.split("/").filter(Boolean)[0] || "";

    console.log("Current pathname:", location.pathname);
    console.log("path ====>>", path);

    const menuMapping = {
      "": { key: "dashboard", title: "Dashboard" },
      Dashboardpage: { key: "dashboard", title: "Dashboard" },
      Analytics: { key: "Analytics", title: "Analytics" },
      users: { key: "users", title: "User's" },
      payouts: { key: "payouts", title: "Payouts" },
      bbps: { key: "paybills", title: "Pay Bills" },
      PaymentLinks: {
        key: "paymentlinks",
        title: "Payment Links",
      },
      ActiveQR: { key: "activateqr", title: "Active QR" },
      getPaid: { key: "GetPaid", title: "Get Paid" },
      PayService: { key: "My Payouts", title: "My Payouts" },
      ContactDetails: { key: "My Payouts", title: "My Payouts" },
      cfmDetails: { key: "My Payouts", title: "My Payouts" },
      Pos: { key: "Pos", title: "POS" },
      History: { key: "History", title: "History" },
      CreditCardBillPayments: {
        key: "CreditCardBillPayments",
        title: "Credit Card Bill Payment",
      },
      CreditCardInstantPay: {
        key: "CreditCardInstantPay",
        title: "Credit Card Bill Payment",
      },
      CreditCardInstantBbps: {
        key: "CreditCardInstantBbps",
        title: "Credit Card Bill Payment",
      },
      login: {
        key: "Logout",
        title: "Logout",
      },
      Settlement: {
        key: "Settlements",
        title: "Settlements",
      },
      SettlementDetails: {
        key: "Settlements",
        title: "Settlements",
      },
      settlementBank: {
        key: "Settlements",
        title: "Settlements",
      },
    };

    if (menuMapping[path]) {
      console.log("menuMapping[path] ===>", menuMapping[path]);
      setSelectedMenu(menuMapping[path].key);
      setSelectedMenuTitle(menuMapping[path].title);
      localStorage.setItem("selectedMenu", menuMapping[path].key);
      localStorage.setItem("selectedMenuTitle", menuMapping[path].title);
    }
  }, [location.pathname]);

  const getActiveAppServices = async () => {
    const token = await GetWebAccessToken();
    try {
      const Headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(`${apiUrl}/activeFeatures/get/all`, {
        headers: Headers,
      });

      const features = response.data;
      dispatch(setFeatures(features));
      setActiveFeatures(features);
    } catch (err) {
      console.log("some thing went wrong", err);
    } finally {
      setActiveFeaturesLoading(false);
    }
  };

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [copied]);

  useEffect(() => {
    if (isHomeRoute === "/login" || !isAuthenticated) {
      setActiveFeaturesLoading(false);
      return;
    }

    getUserDetails();
    getActiveAppServices();

    const interval = setInterval(() => {
      getActiveAppServices();
    }, 900000);

    return () => clearInterval(interval);
  }, [isAuthenticated, isHomeRoute]);

  const FetchVersionCheck = async () => {
    try {
      const versionResp = await axios.get(`${apiUrl}/merchant/getVersion`);
      if (versionResp?.data?.length > 0) {
        const currentVersion = versionResp.data[0].webAppVersion;
        const versionOfWebApp = localStorage.getItem("appVersion");

        const versionChanged = versionOfWebApp !== currentVersion;
        const isWebAppDisabled = versionResp.data[0].webAppDisabled;

        if (versionChanged) {
          localStorage.setItem("appVersion", currentVersion);
          window.location.reload();
          return true;
        } else {
          localStorage.setItem("appVersion", currentVersion);
        }
      }

      return false;
    } catch (error) {
      console.error("Error while checking version:", error);
      return false;
    }
  };

  const handleNavigate = async (menu) => {
    setFilteredSuggestions([]);
    setSearchText("");
    // sessionStorage.removeItem("isReloadingAddAmount", "true");
    // const updateRequired = await FetchVersionCheck();

    // if (updateRequired) return;
    // localStorage.setItem("selectedMenu", menu);
    dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
    let menuTitle = "";

    // Close mobile menu after navigation
    if (isMobile) {
      setMobileMenuOpen(false);
    }

    switch (menu) {
      case "dashboard":
        menuTitle = "Dashboard";
        navigate("/");
        break;
      case "Analytics":
        menuTitle = "Analytics";
        navigate("/Analytics");
        break;
      case "users":
        menuTitle = "User's";
        navigate("/users");
        break;
      case "FerryBooking":
        menuTitle = "Ferry Booking";
        navigate("/Ferry_LocationSearch");
        break;
      case "MyVendors":
        menuTitle = "MyVendors";
        navigate("/vendors");
        break;
      case "Educational":
        menuTitle = "Educational";
        navigate("/eduSelect");
        break;
      case "payouts":
        menuTitle = "Payouts";
        navigate("/payouts");
        break;
      case "account-details":
        menuTitle = "Account Details";
        navigate("/account-details");
        break;
      case "ProfileDetails":
        menuTitle = "Profile Details";
        break;
      case "paybills":
        menuTitle = "Pay Bills";
        navigate("/bbps");
        break;
      case "paymentlinks":
        menuTitle = "Payment Links";
        navigate("/PaymentLinks", { replace: true });
        break;
      case "activateqr":
        menuTitle = "Active QR";
        navigate("/ActiveQR", { replace: true });
        break;
      case "GetPaid":
        menuTitle = "Get Paid";
        navigate("/getPaid", { replace: true });
        break;
      case "MyPayouts":
        menuTitle = "My Payouts";
        navigate("/PayService", {
          state: { previewShow: false, AddingPay: false },
          replace: true,
        });
        setMenuKey((prev) => prev + 1);
        break;
      case "ProPartnerAnalytics":
        menuTitle = "ProPartnerAnalytics";
        navigate("/ProPartnerAnalytics");
        break;
      case "ProPartnerUser's":
        menuTitle = "ProPartnerUser's";
        navigate("/ProPartnerUsers");
        break;
      case "ProPartnerPayouts":
        menuTitle = "ProPartnerPayouts";
        navigate("/ProPartnerPayouts");
        break;
      case "History":
        menuTitle = "History";
        navigate("/History", { replace: true });
        break;
      case "Pos":
        menuTitle = "POS";
        navigate("/Pos", { replace: true });
        break;
      case "Payrent":
        menuTitle = "Pay Rent";
        navigate("/PayRent");
        break;
      case "User's":
        menuTitle = "User's";
        navigate("/Users");
        break;
      case "Payouts":
        menuTitle = "Payouts";
        navigate("/Payouts");
        break;
      case "AccountDetails":
        menuTitle = "Account Details";
        navigate("/AccountDetails");
        break;
      case "CreditCardBillPayments":
        menuTitle = "Credit Card Bill Payment";
        navigate("/CreditCardBillPayments", { replace: true });
        break;
      case "CreditCardInstantPay":
        menuTitle = "Credit Card Bill Payment";
        navigate("/CreditCardInstantPay", { replace: true });
        break;
      case "CreditCardInstantBbps":
        menuTitle = "Credit Card Bill Payment";
        navigate("/CreditCardInstantBbps", { replace: true });
        break;
      case "Settlements":
        menuTitle = "Settlements";
        navigate("/Settlement", { replace: true });
        break;
      case "Logout":
        console.log("logout clicked==>>>");
        console.log("clearing cookies==>>");

        localStorage.removeItem("selectedMenu");
        localStorage.removeItem("selectedMenuTitle");

        if (phNo === "9999999999") {
          localStorage.removeItem("dummyUserPhoneNo");
          localStorage.removeItem("tokenDummy");
          sessionStorage.clear();
          Cookies.remove("token");
          Cookies.remove("MerchantId");
          Cookies.remove("mobileNumber");
        } else {
          Cookies.remove("token");
          Cookies.remove("MerchantId");
          Cookies.remove("mobileNumber");
          sessionStorage.clear();
        }

        menuTitle = "Logout";
        navigate("/login", { replace: true });
        break;

      default:
        break;
    }
    setSelectedMenuTitle(menuTitle);
    // localStorage.setItem("selectedMenuTitle", menuTitle);
    setSelectedMenu(menu);
  };

  useEffect(() => {
    dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
    handleResize();
    setPhNo(localStorage.getItem("dummyUserPhoneNo"));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (userDetails) {
      getUserImage();
    }
  }, [userDetails]);

  const getUserImage = async () => {
    const token = await GetWebAccessToken();
    try {
      const userImageRes = await Call_Api(
        path?.GET_USER_IMAGE(userDetails?.MerchantId),
        "GET",
        {},
        token,
      );
      console.log("User image response:", userImageRes);

      const base64Image = userImageRes?.response?.userimage;

      if (
        userImageRes?.success &&
        typeof base64Image === "string" &&
        base64Image.length > 100
      ) {
        dispatch(StoreImage(base64Image));
      } else {
        dispatch(StoreImage(base64Image));
      }
    } catch (err) {
      console.log("error in getting user image", err);
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchText(query);

    if (query.length > 0) {
      const matches = (getPathItems(userDetails?.walletStatus) || []).filter(
        (item) => item.toLowerCase().includes(query.toLowerCase()),
      );
      setFilteredSuggestions(matches);
    } else {
      setFilteredSuggestions([]);
    }
  };

  const handleSuggestionClick = (route) => {
    const isBBPS = route.startsWith("bbps/");
    const serviceFromRoute = isBBPS ? route.split("bbps/")[1] : "";

    setSearchText("");
    setFilteredSuggestions([]);

    if (isBBPS) {
      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          payOutFee: "0",
          payOutPercentage: 0,
          payOutChargedAmount: 0,
          chargedAmount: 0,
          creditCardNumber: "",
          paymentSource: "webApp",
          serviceName: serviceFromRoute,
        }),
      );

      navigate(`/${route}`, {
        state: {
          record: serviceFromRoute,
          cardData: "",
          billUnique: "",
          key: "",
          fromSearch: true,
        },
      });
    } else {
      navigate(`/${route}`);
    }
  };

  const handleCopy = (copydata) => {
    setCopied(true);
    navigator.clipboard.writeText(copydata || "");
  };

  const handleLogoutConfirm = async () => {
    setShowLogoutConfirm(false);
    await handleNavigate("Logout");
  };

  return (
    <>
      {activeFeaturesLoading ? (
        <Loaders />
      ) : (
        <div className="app-layout">
          {/* Sidebar */}
          <aside
            className={`sidebar ${sidebarOpen ? "open" : ""} ${mobileMenuOpen ? "mobile-open" : ""}`}
          >
            <div className="sidebar-content">
              {/* Logo */}
              <div className="sidebar-logo">
                <img
                  src={ImagesPath?.Demo?.ntarbizzlogo}
                  alt="NTAR Bizz Logo"
                  className="logo-image"
                />
              </div>

              {/* Menu Items */}
              <nav className="sidebar-nav">
                {/* Dashboard */}
                <button
                  className={`menu-item ${selectedMenu === "dashboard" ? "active" : ""}`}
                  onClick={() => handleNavigate("dashboard")}
                >
                  <GridViewIcon className="menu-icon" />
                  <span className="menu-text">{data?.Dashboard}</span>
                </button>

                {/* Bill Payments Section */}
                <div className="menu-section">
                  <div className="section-title">BILL PAYMENTS</div>

                  <button
                    className={`menu-item ${selectedMenu === "paybills" ? "active" : ""}`}
                    onClick={() => handleNavigate("paybills")}
                  >
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.PayBillIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.PayBills}</span>
                    <img
                      className="badge-icon"
                      src={ImagesPath?.Demo?.Bharatconnect}
                      alt=""
                    />
                  </button>

                  {phNo === "9999999999" && (
                    <button
                      className={`menu-item ${selectedMenu === "FerryBooking" ? "active" : ""}`}
                      onClick={() => handleNavigate("FerryBooking")}
                    >
                      <img
                        className="menu-icon"
                        src={ImagesPath?.Demo?.PayBillIcon}
                        alt=""
                      />
                      <span className="menu-text">{data?.Ferry}</span>
                    </button>
                  )}

                  {userDetails?.walletStatus?.toLowerCase() != "active" && (
                    <button
                      className={`menu-item ${selectedMenu === "CreditCardBillPayments" ? "active" : ""}`}
                      onClick={() => handleNavigate("CreditCardBillPayments")}
                    >
                      <img
                        className="menu-icon"
                        src={ImagesPath?.Demo?.CCBillIcon}
                        alt=""
                      />
                      <span className="menu-text">{data?.creditBill}</span>
                    </button>
                  )}

                  {isFeatureActive(
                    features,
                    "Credit_Card_Bill_Payment",
                    "INSTANT_BBPS",
                  ) &&
                    userDetails?.walletStatus?.toLowerCase() == "active" && (
                      <button
                        className={`menu-item ${selectedMenu === "CreditCardInstantBbps" ? "active" : ""}`}
                        onClick={() => handleNavigate("CreditCardInstantBbps")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.CCBillIcon}
                          alt=""
                        />
                        <span className="menu-text">
                          {getSettlementDisplayName(
                            features,
                            "Credit_Card_Bill_Payment",
                            "INSTANT_BBPS",
                          )}
                        </span>
                      </button>
                    )}

                  {isFeatureActive(
                    features,
                    "Credit_Card_Bill_Payment",
                    "INSTANT_PAY",
                  ) &&
                    userDetails?.walletStatus?.toLowerCase() == "active" && (
                      <button
                        className={`menu-item ${selectedMenu === "CreditCardInstantPay" ? "active" : ""}`}
                        onClick={() => handleNavigate("CreditCardInstantPay")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.CCBillIcon}
                          alt=""
                        />
                        <span className="menu-text">
                          {getSettlementDisplayName(
                            features,
                            "Credit_Card_Bill_Payment",
                            "INSTANT_PAY",
                          )}
                        </span>
                      </button>
                    )}

                  {userDetails?.walletStatus?.trim()?.toLowerCase() ===
                    "active" &&
                    userDetails?.allowWalletSettlements.includes(
                      "Settlements",
                    ) &&
                    isFeatureActive(features, "Settlements", "Transfer") && (
                      <button
                        className={`menu-item ${selectedMenu === "Settlements" ? "active" : ""}`}
                        onClick={() => handleNavigate("Settlements")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.SettlementsIcon}
                          alt=""
                        />
                        <span className="menu-text">{data?.settlements}</span>
                      </button>
                    )}
                </div>

                {/* Collect Section */}
                <div className="menu-section">
                  <div className="section-title">COLLECT</div>

                  {userDetails?.walletStatus?.trim()?.toLowerCase() ===
                    "active" &&
                    userDetails?.allowWalletSettlements.includes(
                      "Settlements",
                    ) &&
                    isFeatureActive(features, "Settlements", "Settlements") && (
                      <button
                        className={`menu-item ${selectedMenu === "GetPaid" ? "active" : ""}`}
                        onClick={() => handleNavigate("GetPaid")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.GedPaidIcon}
                          alt=""
                        />
                        <span className="menu-text">{data?.gp}</span>
                      </button>
                    )}

                  {userDetails?.allowWalletSettlements?.includes(
                    "PAYMENT_LINKS",
                  ) &&
                    isFeatureActive(
                      features,
                      "Payment_Links",
                      "Payment_Links",
                    ) &&
                    userDetails?.walletStatus?.toLowerCase() == "active" && (
                      <button
                        className={`menu-item ${selectedMenu === "paymentlinks" ? "active" : ""}`}
                        onClick={() => handleNavigate("paymentlinks")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.PaymentLinksIcon}
                          alt=""
                        />
                        <span className="menu-text">{data?.payL}</span>
                      </button>
                    )}

                  <button
                    className={`menu-item ${selectedMenu === "Pos" ? "active" : ""}`}
                    onClick={() => handleNavigate("Pos")}
                  >
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.PosIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.pos}</span>
                  </button>

                  <button
                    className={`menu-item ${selectedMenu === "activateqr" ? "active" : ""}`}
                    onClick={() => handleNavigate("activateqr")}
                  >
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.QrIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.ActiveQR}</span>
                  </button>
                </div>

                {/* Payouts Section */}
                <div className="menu-section">
                  <div className="section-title">PAYOUTS</div>

                  {userDetails?.walletStatus?.trim()?.toLowerCase() ===
                    "active" &&
                    userDetails?.allowWalletSettlements.includes(
                      "PayOut_Settlements",
                    ) &&
                    isFeatureActive(
                      features,
                      "PayOut_Settlements",
                      "PayOut_Settlements",
                    ) && (
                      <button
                        className={`menu-item ${selectedMenu === "My Payouts" ? "active" : ""}`}
                        onClick={() => handleNavigate("MyPayouts")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.PayBillIcon}
                          alt=""
                        />
                        <span className="menu-text">{data?.Pay}</span>
                      </button>
                    )}

                  {/* {isFeatureActive(features, "Vendors", "Vendors") && (
                    <button
                      className={`menu-item ${selectedMenu === "My Vendors" ? "active" : ""}`}
                      onClick={() => handleNavigate("MyVendors")}
                    >
                      <img
                        className="menu-icon"
                        src={ImagesPath?.Demo?.PayBillIcon}
                        alt=""
                      />
                      <span className="menu-text">{data?.vendorPay}</span>
                    </button>
                  )} */}

                  {/* {phNo === "9999999999" && isFeatureActive(features, "Educational", "Educational") && ( */}
                  {phNo === "9999999999" && (
                    <button
                      className={`menu-item ${selectedMenu === "Educational" ? "active" : ""}`}
                      onClick={() => handleNavigate("Educational")}
                    >
                      <img
                        className="menu-icon"
                        src={ImagesPath?.Demo?.PayBillIcon}
                        alt=""
                      />
                      <span className="menu-text">{data?.Educational}</span>
                    </button>
                  )}
                </div>

                {/* Partner Section */}
                {userDetails?.allowPartnerStatus?.toLowerCase() === "active" &&
                  userDetails?.walletStatus?.toLowerCase() == "active" &&
                  userDetails?.walletStatus && (
                    <div className="menu-section">
                      <div className="section-title">PARTNER</div>

                      <button
                        className="menu-item submenu-toggle"
                        onClick={() => toggleSubmenu("partner")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.PartnerIcon}
                          alt=""
                        />
                        <span className="menu-text">Partner</span>
                        {openSubmenus.partner ? (
                          <ExpandLessIcon className="expand-icon" />
                        ) : (
                          <ExpandMoreIcon className="expand-icon" />
                        )}
                      </button>

                      {openSubmenus.partner && (
                        <div className="submenu">
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "Analytics" ? "active" : ""}`}
                            onClick={() => handleNavigate("Analytics")}
                          >
                            <span className="menu-text">{data?.Analytics}</span>
                          </button>
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "User's" ? "active" : ""}`}
                            onClick={() => handleNavigate("User's")}
                          >
                            <span className="menu-text">{data?.user}</span>
                          </button>
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "Payouts" ? "active" : ""}`}
                            onClick={() => handleNavigate("Payouts")}
                          >
                            <span className="menu-text">{data?.payout}</span>
                          </button>
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "AccountDetails" ? "active" : ""}`}
                            onClick={() => handleNavigate("AccountDetails")}
                          >
                            <span className="menu-text">{data?.account}</span>
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                {/* Pro-Partner Section */}
                {userDetails?.propartnerStatus?.toLowerCase() === "active" &&
                  userDetails?.walletStatus?.toLowerCase() == "active" && (
                    <div className="menu-section">
                      <button
                        className="menu-item submenu-toggle"
                        onClick={() => toggleSubmenu("propartner")}
                      >
                        <img
                          className="menu-icon"
                          src={ImagesPath?.Demo?.PartnerIcon}
                          alt=""
                        />
                        <span className="menu-text">Pro-Partner</span>
                        {openSubmenus.propartner ? (
                          <ExpandLessIcon className="expand-icon" />
                        ) : (
                          <ExpandMoreIcon className="expand-icon" />
                        )}
                      </button>

                      {openSubmenus.propartner && (
                        <div className="submenu">
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "ProPartnerAnalytics" ? "active" : ""}`}
                            onClick={() =>
                              handleNavigate("ProPartnerAnalytics")
                            }
                          >
                            <span className="menu-text">{data?.Analytics}</span>
                          </button>
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "ProPartnerUser's" ? "active" : ""}`}
                            onClick={() => handleNavigate("ProPartnerUser's")}
                          >
                            <span className="menu-text">{data?.user}</span>
                          </button>
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "ProPartnerPayouts" ? "active" : ""}`}
                            onClick={() => handleNavigate("ProPartnerPayouts")}
                          >
                            <span className="menu-text">{data?.payout}</span>
                          </button>
                          <button
                            className={`menu-item submenu-item ${selectedMenu === "AccountDetails" ? "active" : ""}`}
                            onClick={() => handleNavigate("AccountDetails")}
                          >
                            <span className="menu-text">{data?.account}</span>
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                {/* Bottom Menu Items */}
                <div className="menu-section">
                  <button className="menu-item">
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.ReferralIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.Referral}</span>
                  </button>

                  <button
                    className={`menu-item ${selectedMenu === "History" ? "active" : ""}`}
                    onClick={() => handleNavigate("History")}
                  >
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.TransactionsIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.Transactions}</span>
                  </button>

                  <button className="menu-item">
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.HelpIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.Help}</span>
                  </button>

                  <button
                    className="menu-item logout-item"
                    onClick={() => setShowLogoutConfirm(true)}
                  >
                    <img
                      className="menu-icon"
                      src={ImagesPath?.Demo?.LogoutIcon}
                      alt=""
                    />
                    <span className="menu-text">{data?.lg}</span>
                  </button>
                </div>
              </nav>
            </div>
          </aside>

          {/* Main Content Area */}
          <div className="main-wrapper">
            {/* Header */}
            <header className="app-header">
              <div className="header-left">
                <button
                  className="menu-toggle"
                  onClick={isMobile ? toggleMobileMenu : toggleSidebar}
                >
                  {isMobile ? (
                    mobileMenuOpen ? (
                      <CloseIcon />
                    ) : (
                      <MenuIcon />
                    )
                  ) : (
                    <MenuIcon />
                  )}
                </button>
              </div>

              <div className="header-search-plusetc">
                <div className="header-center">
                  <div className="search-container-demo">
                    <SearchIcon className="search-icon-demo" />
                    <input
                      type="text"
                      placeholder="Search here"
                      className="search-input-demo"
                      value={searchText}
                      onChange={handleSearchChange}
                    />
                    {searchText && (
                      <CloseIcon
                        className="cross_icon_demo"
                        onClick={() => {
                          setSearchText("");
                          setFilteredSuggestions([]);
                        }}
                        fontSize="Medium"
                      />
                    )}{" "}
                    {filteredSuggestions.length > 0 && (
                      <ul className="suggestions-dropdown">
                        {filteredSuggestions.map((item, index) => (
                          <li
                            key={index}
                            className="suggestion-item"
                            onClick={() => handleSuggestionClick(item)}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                <div className="header-right">
                  <button className="add-button">
                    <img src={ImagesPath?.Demo?.Plus} alt="Add" />
                  </button>

                  {userDetails?.walletStatus?.toLowerCase() == "active" && (
                    <div className="wallet-balance">
                      <img
                        className="coin-icon"
                        src={ImagesPath?.Demo?.ntarbizzcoin}
                        alt="Coin"
                      />
                      <span>{Math.floor(userDetails?.walletBalance)}</span>
                    </div>
                  )}

                  <div className="divider"></div>

                  <div className="user-profile">
                    <img
                      className="profile-image"
                      src={
                        userDetails?.userimage !== "true" &&
                        typeof userDetails?.userimage === "string"
                          ? `data:image/png;base64,${userDetails?.userimage}`
                          : userImage
                            ? `data:image/png;base64,${userImage}`
                            : ImagesPath?.Demo?.Profile
                      }
                      alt="Profile"
                    />
                    <div className="profile-info">
                      <span className="profile-name">{userName}</span>
                      <span className="merchant-id">
                        {data?.mID} {userDetails?.MerchantId}
                        <span className="copy-wrapper">
                          <ContentCopyIcon
                            style={{
                              fontSize: "0.7rem",
                              marginLeft: "4px",
                              cursor: "pointer",
                            }}
                            titleAccess="Copy"
                            onClick={() => handleCopy(userDetails?.MerchantId)}
                          />
                          {copied && (
                            <span className="copied-tooltip">Copied!</span>
                          )}
                        </span>
                      </span>
                    </div>
                  </div>

                  <div className="divider"></div>

                  <button className="help-button">
                    <HelpOutlineIcon />
                  </button>
                </div>
              </div>
            </header>

            {/* Content */}
            <main className="app-content">
              <Outlet />
            </main>

            {/* Footer */}
            {!hiddenFooterPaths.includes(location.pathname) && (
              <footer className="app-footer">
                <Footer />
              </footer>
            )}
          </div>

          {/* Logout Confirmation Modal */}
          {showLogoutConfirm && (
            <div
              className="modal-overlay"
              onClick={() => setShowLogoutConfirm(false)}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <h3>Logging Out</h3>
                <p>Are you sure you want to logout?</p>
                <div className="modal-actions">
                  <button
                    className="btn-cancel"
                    onClick={() => setShowLogoutConfirm(false)}
                  >
                    No
                  </button>
                  <button className="btn-confirm" onClick={handleLogoutConfirm}>
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Mobile Menu Overlay */}
          {isMobile && mobileMenuOpen && (
            <div className="mobile-overlay" onClick={toggleMobileMenu}></div>
          )}
        </div>
      )}
    </>
  );
};

export default memo(Demo);
